import { CommodityFilterInput, CommodityStats } from '@bechtel/types';
import { useLazyQuery, QueryTuple } from '@apollo/client';
import { GET_COMMODITY_WEEKLY_STATS, GET_COMMODITY_DASHBOARD_TAB_STATS } from '@bechtel/client-gql';

export function useWeeklyCommodityStatsQuery(
  fetchFromNetwork?: boolean
): QueryTuple<{ commodityStats: CommodityStats }, { input: CommodityFilterInput }> {
  const response = useLazyQuery<{ commodityStats: CommodityStats }, { input: CommodityFilterInput }>(
    GET_COMMODITY_WEEKLY_STATS,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'no-cache',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}

export function useCommodityDashboardTabStatsQuery(
  fetchFromNetwork?: boolean
): QueryTuple<{ commodityStats: CommodityStats }, { input: CommodityFilterInput }> {
  const response = useLazyQuery<{ commodityStats: CommodityStats }, { input: CommodityFilterInput }>(
    GET_COMMODITY_DASHBOARD_TAB_STATS,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'no-cache',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
